import * as formik from 'formik';
import * as yup from 'yup';

import AppButton from "../../../commons/buttons/AppButton";
import AppInput from "../../../commons/inputs/AppInput";
import AppLoading from "../../../commons/AppLoading";
import CompanyAPI from '../../company/CompanyAPI';
import EmployeeAPI from '../../employee/EmployeeAPI';
import { Form } from 'react-bootstrap';
import HallAppToast from '../../../commons/HallAppToast';
import { Modal } from "react-bootstrap";
import { useState } from "react";

const companyAPI = new CompanyAPI();
const employeeAPI = new EmployeeAPI();

function CashClosingPayModal({ closeShow, show, filter, employee, findAllSummary, payPending = false }) {
    const [initialValues, setInitialValues] = useState({
        description: '',
    });

    const [isLoading, setLoading] = useState(false);

    const { Formik } = formik;

    const schema = yup.object().shape({
        description: yup.string().max(100, 'Descrição deve ter no maximo 100 cracteres')
    });


    const pay = async (values) => {
        const data = {
            startDate: filter.startDate,
            endDate: filter.endDate,
            companyId: companyAPI.getCompanyManagment().id,
            description: values.description
        }
        
        try {
            setLoading(true)
            await employeeAPI.pay(employee.employeeId, data);
            closeShow()
            if (findAllSummary) {
                findAllSummary()
            }
            HallAppToast.success();
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setLoading(false)
        }
    }

    const payAll = async (values) => {
        const data = {
            companyId: companyAPI.getCompanyManagment().id,
            description: values.description
        }
    
        try {
            setLoading(true)
            await employeeAPI.payPending(employee.employeeId, data);
            closeShow()
            if (findAllSummary) {
                findAllSummary()
            }
            HallAppToast.success();
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setLoading(false)
        }
    }


    return (
        <>
            <Modal show={show} fullscreen={false} centered={true} onHide={() => closeShow()}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        CONFIRMAR PAGAMENTO
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        validationSchema={schema}
                        onSubmit={payPending ? payAll : pay}
                        initialValues={initialValues}
                        enableReinitialize={true}
                    >
                        {({ handleSubmit, handleChange, values, touched, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>


                                <AppInput errors={errors}
                                    touched={touched}
                                    name='description'
                                    onChange={handleChange}
                                    value={values.description}
                                    type='text'
                                    label='Descrição' />

                                {isLoading ? <AppLoading /> :
                                    <AppButton type="submit" width='100%' name='confirmar' />
                                }
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CashClosingPayModal;